import api from '@/plugins/api';
import { checkError, prepareApiParams } from 'erp-skeleton-library/utils';
import { usersTenants } from '@/plugins/enums';
import customers from './parties/customers';

const state = {
  allUserTenants: [],
  tableLoading: false,
  headers: [
    {
      text: 'Nome',
      value: 'name',
    },
    {
      text: 'Email',
      value: 'email',
    },
    {
      text: 'Tipo',
      value: 'type',
      sortable: false,
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allUserTenants = payload;
    state.tableLoading = false;
  },
};

const actions = {
  list({ commit }, payload) {
    return new Promise((resolve, reject) => {
      state.tableLoading = true;
      let query = prepareApiParams(payload.apiParams, 'id, name, email, tenants{type}');
      query['tenants{tenant}'] = payload.customerId;
      query['tenants{type}'] = '{' + usersTenants.TYPE_ADMIN + ', ' + usersTenants.TYPE_USER + '}';

      api.get('users?' + new URLSearchParams(query).toString())
         .then(response => {
           commit('LIST', response.data.entities);
           resolve(response.data);
         })
         .catch(error => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('users/' + id + '/tenants/' + customers.state.registerCustomer.id)
         .then((response) => resolve(response.data))
         .catch((error) => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

